import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getOr } from 'lodash/fp';
import { Button, ButtonGroup, Content, Icon } from 'rsuite';
import {
  fetchROItemForEdit,
  updateROItem,
  deleteROItem
} from '../../../../redux/Reservation/sagas/routines';
import { resetROItemEdit } from '../../../../redux/Reservation/actions/routes/ro-item/edit';
import {
  getROItemEditData,
  getIsSaving,
  getIsSaved
} from '../../../../redux/Reservation/selectors/routes/ro-item/edit';
import { fullAccess, modifyAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/reservations/PageLayout';
import ROItemForm from '../../../../components/reservations/ROItemForm';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import ButtonToolbar from '../../../../components/reservations/ButtonToolbar';
import history from '../../../history';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';
import {
  reservationsROItemListPath,
  reservationsROItemViewPath
} from '../../../Paths';
import { getIsDeleting } from '../../../../redux/Reservation/selectors/ro-item';
import Breadcrumb from '../../../../components/Breadcrumb';
import DeleteConfirmationModal from '../../../../components/DeleteConfirmationModal';

export default () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const item = useSelector(getROItemEditData);
  const isSaving = useSelector(getIsSaving);
  const isSaved = useSelector(getIsSaved);
  const isDeleting = useSelector(getIsDeleting);

  const handleView = () => {
    history.push(pagePathToUrl(reservationsROItemViewPath, { id }));
  };

  const handleSubmit = body => {
    dispatch(updateROItem({ id, body }));
  };

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleHideDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDeleteItem = () => {
    setShowDeleteModal(false);
    dispatch(deleteROItem(item));
    setTimeout(() => {
      history.push(reservationsROItemListPath);
    }, 200);
  };

  useEffect(
    () => {
      dispatch(fetchROItemForEdit(id));
      return function reset() {
        dispatch(resetROItemEdit());
      };
    },
    [id]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={modifyAccess(PERMISSIONS.RO_ITEM)}
        fallback={<AccessDenied />}
      >
        <Breadcrumb
          items={[
            {
              path: reservationsROItemListPath,
              label: 'Items'
            },
            {
              path: pagePathToUrl(reservationsROItemViewPath, { id }),
              label: getOr('...', 'name', item)
            },
            { label: `Edit Item` }
          ]}
        />
        <PageHeader title="Edit Item">
          <ButtonToolbar>
            <ButtonGroup>
              <Button size="sm" appearance="primary" onClick={handleView}>
                <Icon icon="eye" /> View
              </Button>
            </ButtonGroup>
            <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.RO_ITEM)}>
              <ButtonGroup>
                <Button size="sm" onClick={handleShowDeleteModal} color="red">
                  <Icon icon="trash" /> Delete
                </Button>
              </ButtonGroup>
            </AccessControl>
          </ButtonToolbar>
        </PageHeader>
        <Content style={{ marginTop: 0 }}>
          {item && (
            <ROItemForm
              onSubmit={handleSubmit}
              isSaving={isSaving}
              isSaved={isSaved}
              data={item}
            />
          )}

          <DeleteConfirmationModal
            message="Warning: Deleting Item will also remove the Item from the Pick Lists. Are you sure you want to delete this Item?"
            show={showDeleteModal}
            onHide={handleHideDeleteModal}
            onConfirm={handleConfirmDeleteItem}
            isDeleting={isDeleting}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
